// extracted by mini-css-extract-plugin
export default {"id":"wtQfvf9qAz","confirm-input":"RTM6Dd42mB","confirmInput":"RTM6Dd42mB","hard-delete-checkbox":"biGYdvU6ob","hardDeleteCheckbox":"biGYdvU6ob"};
    if(module.hot) {
      // 1643570407822
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  